/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Many-to-many link between a contact and an organization
 * @export
 * @interface ContactOrganization
 */
export interface ContactOrganization {
    /**
     * 
     * @type {number}
     * @memberof ContactOrganization
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ContactOrganization
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ContactOrganization
     */
    contactId: number;
    /**
     * 
     * @type {number}
     * @memberof ContactOrganization
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof ContactOrganization
     */
    role?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactOrganization
     */
    isPrimary: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactOrganization
     */
    notes?: string | null;
    /**
     * Enriched org name from joined organization table
     * @type {string}
     * @memberof ContactOrganization
     */
    organizationName?: string;
    /**
     * Organization type (insurer, contractor, etc.)
     * @type {string}
     * @memberof ContactOrganization
     */
    orgType?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactOrganization
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ContactOrganization interface.
 */
export function instanceOfContactOrganization(value: object): value is ContactOrganization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('isPrimary' in value) || value['isPrimary'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ContactOrganizationFromJSON(json: any): ContactOrganization {
    return ContactOrganizationFromJSONTyped(json, false);
}

export function ContactOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'contactId': json['contactId'],
        'organizationId': json['organizationId'],
        'role': json['role'] == null ? undefined : json['role'],
        'isPrimary': json['isPrimary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'orgType': json['orgType'] == null ? undefined : json['orgType'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ContactOrganizationToJSON(json: any): ContactOrganization {
    return ContactOrganizationToJSONTyped(json, false);
}

export function ContactOrganizationToJSONTyped(value?: ContactOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'contactId': value['contactId'],
        'organizationId': value['organizationId'],
        'role': value['role'],
        'isPrimary': value['isPrimary'],
        'notes': value['notes'],
        'organizationName': value['organizationName'],
        'orgType': value['orgType'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

